import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import { buildCasdoorAuthorizeUrl, LoginPage } from '../auth/LoginPage';
import { OAuthCallback } from '../auth/OAuthCallback';
import { WelcomePage } from '../pages/welcome/WelcomePage';
import { useSessionStore } from '../store/sessionStore';
import { ProtectedShell } from './ProtectedShell';

function RedirectToLogin() {
  const location = useLocation();
  useEffect(() => {
    const from = `${location.pathname}${location.search}${location.hash}` || '/';
    window.location.replace(buildCasdoorAuthorizeUrl(from));
  }, [location.hash, location.pathname, location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center text-foreground-muted">
      正在跳转登录…
    </div>
  );
}

function RequireAuth({ children }: { children: JSX.Element }) {
  const status = useSessionStore((s) => s.status);
  const bootstrapError = useSessionStore((s) => s.bootstrapError);
  if (bootstrapError) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface text-foreground">
        <div className="max-w-md rounded-lg border border-danger/30 bg-surface-muted p-6 text-center">
          <h1 className="text-lg font-semibold">无法验证当前会话</h1>
          <p role="alert" className="mt-2 text-sm text-foreground-muted">
            {bootstrapError}
          </p>
          <button
            type="button"
            className="mt-4 rounded bg-primary px-3 py-2 text-sm text-primary-foreground"
            onClick={() => window.location.reload()}
          >
            重试
          </button>
        </div>
      </div>
    );
  }
  if (status === 'unknown') {
    return (
      <div className="min-h-screen flex items-center justify-center text-foreground-muted">
        加载会话…
      </div>
    );
  }
  if (status === 'anonymous') return <RedirectToLogin />;
  return children;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/oauth/:provider/callback"
          element={<OAuthCallback />}
        />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <ProtectedShell />
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
